/*! ngclipboard - v1.1.1 - 2016-02-26
* https://github.com/sachinchoolur/ngclipboard
* Copyright (c) 2016 Sachin; Licensed MIT */

(function () {
	'use strict';

	angular
	.module('directive.ngclipboard', [])

    /* @ngInject */
    .factory('ClipboardService', ["Environment", function (Environment) {
      var load,
        queue = [];

      var service = {
        add: add
      };
      return service;

      ////////////

      function add(element, scope) {
        if (angular.isUndefined(window.ClipboardJS)) {
          queue.push({ element: element, scope: scope });
          if (!load) {
            load = true;
            $.ajax({
              url: Environment === 'dev' ? '/js/clipboard.js' : '/js/clipboard.min.js',
              dataType: 'script',
              cache: true,
              success: function () {
                start();
              }
            });
          }
        } else {
          init(element, scope);
        }
      }

      function start() {
        _.each(queue, function (item) {
          init(item.element, item.scope);
        });
      }

      function init(element, scope) {
      	var clipboard = new window.ClipboardJS(element[0]);

				clipboard.on('success', function(e) {
					scope.$apply(function () {
						scope.clipboardSuccess({ e: e });
					});
				});

				clipboard.on('error', function(e) {
					scope.$apply(function () {
						scope.clipboardError({ e: e });
					});
				});
      }
    }])

    /* @ngInject */
		.directive('clipboard', ["ClipboardService", function(ClipboardService) {
			return {
				restrict: 'A',
				scope: {
					clipboardSuccess: '&',
					clipboardError: '&'
				},
				link: function(scope, element) {
					ClipboardService.add(element, scope);
  			}
  		};
  	}]);

})();